import { refreshInbox } from "@/hooks/inbox";
import { mutateRequest } from "@/lib/swr";
import type { RolloutTask } from "@/types/domain";

export const ROLLOUT_TASK_LABELS: Record<RolloutTask["type"], string> = {
  // 版本放量后的数据回收(owner 2026-09-08 定名)
  commercial: "收入数据",
  data_check: "版本数据",
};

/** "GP 10%" for a channel-step task; "60%" / "100%" for a version-level stage; empty for a version-level rollout stage without a percent. */
export const rolloutStepLabel = (task: RolloutTask): string => {
  const percent = task.percent != null ? `${task.percent}%` : "";
  if (!task.channelReleaseId) return percent;
  const channel = task.channelRelease?.channel?.name;
  return [channel, percent].filter(Boolean).join(" ");
};

/** "收入数据 · GP 10%" (type + step). */
export const rolloutTaskLabel = (task: RolloutTask): string => {
  const step = rolloutStepLabel(task);
  return step
    ? `${ROLLOUT_TASK_LABELS[task.type]} · ${step}`
    : ROLLOUT_TASK_LABELS[task.type];
};

/** Revalidates every /rollout-tasks list (per-version, per-app) and my inbox. */
export const refreshRolloutTasks = () => {
  mutateRequest("/rollout-tasks");
  refreshInbox();
};
